import { FORMAT_DATE } from './dateFormat'

export const getColor = (username: string): string => {
    const colors = [
        '#ffa38a',
        '#a9a7e0',
        '#D686D4',
        '#96CE56',
        '#4A90E2',
        '#62b3d0',
        '#ef7676',
    ]
    const firstChar = username.charCodeAt(0)
    const secondChar = username.charCodeAt(1)
    const thirdChar = username.charCodeAt(2)

    return colors[(firstChar + secondChar + thirdChar) % 7]
}

export const pad2 = (number: number): string => {
    return (number < 10 ? '0' : '') + number
}

export const handleNumericInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: React.Dispatch<React.SetStateAction<string>>
): void => {
    const value = e.target.value.replace(/[^0-9]/g, '') // Remove non-numeric characters
    setValue(value)
}

export const validateName = async (
    rule: any,
    value: string,
    label: string // Additional label parameter
): Promise<any> => {
    // Check if the value contains numbers
    if (/\d/.test(value)) {
        return await Promise.reject(
            new Error(`${label} cannot be a number or contain numbers!`)
        )
    }
    // Check if the value contains special characters
    if (/[^A-Za-z\s]/.test(value)) {
        return await Promise.reject(
            new Error(`${label} cannot contain special characters!`)
        )
    }
    if (value?.length > 100) {
        return await Promise.reject(
            new Error(`${label} cannot exceed 100 characters!`)
        )
    }
    await Promise.resolve()
}

export const getPayeProcessName = (stdId: number): string => {
    switch (stdId) {
        case 1:
            return 'End of Month'
        case 2:
            return '05th of Next Month'
        case 3:
            return 'Custom Date'
        default:
            return ''
    }
}

export const defaultImageUrl =
    'https://iykons-dev-s3-storage.s3.amazonaws.com/Document/6ef4885e-0670-48ab-8009-6e6b9718724b-WhatsApp Image 2024-11-25 at 11.26.02.jpeg'

export const getDateStatus = (
    serviceId: number,
    periodStartDate: string,
    periodEndDate: string
): string => {
    switch (serviceId) {
        case 1:
            return `Period of ${FORMAT_DATE(periodStartDate)} to ${FORMAT_DATE(periodEndDate)}`
        case 3:
            return `Period of ${FORMAT_DATE(periodStartDate)} to ${FORMAT_DATE(periodEndDate)}`
        case 4:
            return `Period of ${FORMAT_DATE(periodStartDate)} to ${FORMAT_DATE(periodEndDate)}`
        case 9:
            return `Next accounts made up to ${FORMAT_DATE(periodStartDate)}
            due by ${FORMAT_DATE(periodEndDate)}`
        case 10:
            return `Next statement date ${FORMAT_DATE(periodStartDate)} due by ${FORMAT_DATE(periodEndDate)}`
        default:
            return `Next accounts made up to ${FORMAT_DATE(periodStartDate)}
            due by ${FORMAT_DATE(periodEndDate)}`
    }
}
